/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Beta_TitleInputs */

const da_beta_title = /** @type {(inputs: Beta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bed om adgang til betaen`)
};

/** @type {(inputs: Beta_TitleInputs) => LocalizedString} */
const en_beta_title = da_beta_title;

/**

* @param {Beta_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const beta_title = /** @type {((inputs?: Beta_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Beta_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_beta_title(inputs)
	return /** @type {LocalizedString} */ ("Bed om adgang til betaen")
});